import { lazy } from 'react';

export const CoinsStats = lazy(() => import('./CoinsStats.component'));
